<div
  class="min-h-screen flex flex-col items-center justify-center bg-gray-100 dark:bg-gray-800 p-4 text-gray-800 dark:text-gray-200">
  <p-card styleClass="w-full max-w-lg shadow-xl rounded-lg overflow-hidden">
    <ng-template pTemplate="header">
      <div class="flex justify-center items-center p-6 bg-primary-500 text-white">
        <em class="pi pi-lock text-6xl md:text-7xl"></em>
      </div>
    </ng-template>
    <ng-template pTemplate="title">
      <h1 class="text-3xl md:text-4xl font-bold text-center pt-3">Accesso non autorizzato</h1>
    </ng-template>
    <ng-template pTemplate="subtitle">
      <p class="text-lg md:text-xl text-center text-gray-600 dark:text-gray-400">Errore 403</p>
    </ng-template>
    <ng-template pTemplate="content">
      <p class="text-center mb-6 px-4">
        Non hai i permessi necessari per accedere a questa risorsa. Se ritieni che si tratti di un errore, contatta
        l'amministratore di sistema.
      </p>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex justify-center items-center gap-3 p-4 border-t border-gray-200 dark:border-gray-700">
        <p-button
          label="Torna alla Home"
          icon="pi pi-home"
          (click)="goToHome()"
          styleClass="p-button-primary w-full sm:w-auto">
        </p-button>
      </div>
    </ng-template>
  </p-card>
</div>
